import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import PopupWrapper from "../Common/PopupWrapper";
import ComplexParam from "@mnjsplatform/components/lib/common/ComplexParam";
import i18next from "i18next";
import RadioGroupJson from "../Common/RadioGroupJson";
import CheckBoxJson from "../Common/CheckBoxJson";
import parse from "html-react-parser";
import confirm from "@mnjsplatform/components/lib/common/ConfirmFn";

import toastr from 'toastr';
import {GlobalDebugMode} from "@mnjsplatform/data";

const createTaskCustomFieldExMap = {
    RadioGroupJson: (props) => <RadioGroupJson {...props} />,
    CheckBoxJson: (props) => <CheckBoxJson {...props} />
};

/* TEMPLATE EXAMPLE
const template = `
<div class="row mt-2">
    <div class="col-md-3">(Маска 1)
        <strong><label name="Field01"/>:</strong>
    </div>
    <div class="col-md-4">
        <editor name="Field01"/>    
    </div>
</div>
<div class="row mt-2">
    <div class="col-md-3">(Маска 2)
        <strong><label name="Field02"/>:</strong>
    </div>
    <div class="col-md-4">
        <editor name="Field02"/>
    </div>
</div>
<div class="row mt-2"  >
    <div class="col-md-3">(Multiline)
        <strong><label name="Field03"/>:</strong>
    </div>
    <div class="col-md-7" >
        <div style="height:100px"><editor name="Field03"/></div>
    </div>
</div>
<div class="row mt-2">
    <div class="col-md-3 ">(Date)
        <strong><label name="Field04"/>:</strong>
    </div>
    <div class="col-md-4">
        <editor name="Field04"/>
    </div>
</div>
<div class="row  mt-2">
    <div class="col-md-3">(Combo)
        <strong><label name="Field05"/>:</strong>
    </div>
    <div class="col-md-4">
        <editor name="Field05"/>
    </div>
</div>
<div class="row mt-2">
    <div class="col-md-3">(Radio)
        <strong><label name="Field06"/>:</strong>
    </div>
    <div class="col-md-8">
        <editor name="Field06"/>
    </div>
</div>
<div class="row mt-2">
    <div class="col-md-3">(Checkbox)
        <strong><label name="Field07"/>:</strong>
    </div>
    <div class="col-md-4">
        <editor name="Field07"/>
    </div>
</div>
<div class="row mt-2">
    <div class="col-md-3">(Numeric)
        <strong><label name="Field08"/>:</strong>
    </div>
    <div class="col-md-4">
        <editor name="Field08"/>
    </div>
</div>
<div class="row mt-2">
    <div class="col-md-3">(Simple Edit)
        <strong><label name="Field10"/>:</strong>
    </div>
    <div class="col-md-4">
        <editor name="Field10"/>
    </div>
</div>
<br/>
`
*/

class EditClaim extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            templateText: null,
            buttonTextSign: null,
            buttonTextSave: null,
            buttonTextDel: null,
            buttonTextCancel: null
        }
    }

    componentDidMount() {
        this.initialize();
    }

    initialize = async () => {
        try {
            await this.props.dispatch(this.props.ClaimPersGetClaimTempl.reset());
            await this.props.dispatch(this.props.ClaimPersGetClaimTempl.initialize(this.props.claimKey,{
                newItem: true,
                withParams: false
            }));

            if (!this.props.ClaimPersGetClaimTempl.isError)
            {
                const template = this.props.ClaimPersGetClaimTempl.getRow(0);
                this.setState({templateText: template["TemplateText"],
                    buttonTextSign: template["ButtonTextSign"],
                    buttonTextSave: template["ButtonTextSave"],
                    buttonTextDel: template["ButtonTextDel"],
                    buttonTextCancel: template["ButtonTextCancel"]
                });

                await this.props.dispatch(this.props.ClaimPersGetClaimData.reset());
                await this.props.dispatch(this.props.ClaimPersGetClaimData.initialize(this.props.claimKey, {
                    newItem: true,
                    withParams: false
                }));
            }
        } catch {
        }
    };

    save = async () => {
        await this.props.dispatch(this.props.ClaimPersGetClaimData.save());
        if (!this.props.ClaimPersGetClaimData.isError) {
            this.props.onClose(true);
            this.showToastr(i18next.t("Request_Create_Success"));
        }
    };

    pass = async () => {
        try {
            await confirm(i18next.t("Send_Request_Confirm"));

            await this.props.dispatch(this.props.ClaimPersGetClaimData.save());
            if (this.props.ClaimPersGetClaimData.isError) {
                return;
            }

            await this.props.dispatch(this.props.ClaimPersSendClaimForPO.execute(this.props.claimKey, {withParams: false}));
            if (!this.props.ClaimPersSendClaimForPO.isError) {
                this.props.onClose(true);
                this.showToastr(i18next.t("Vacation_Request_Sent"));
            }
        } catch {
        }
    };

    delete = async (e) => {
        e && e.preventDefault();
        try {
            await confirm(i18next.t("Delete_Request_Confirm"));

            await this.props.dispatch(this.props.ClaimPersListForPO_Del.execute(this.props.claimKey, {withParams: false}));
            if (!this.props.ClaimPersListForPO_Del.isError) {
                await this.props.onClose(true);
                this.showToastr(i18next.t("Request_Delete_Success"));
            }
        } catch {
        }
    };

    showToastr = (text) => {
        toastr.options = {
            "closeButton": false,
            "debug": false,
            "newestOnTop": false,
            "progressBar": false,
            "positionClass": "toast-top-center",
            "preventDuplicates": false,
            "onclick": null,
            "showDuration": "300",
            "hideDuration": "1000",
            "timeOut": "4000",
            "extendedTimeOut": "1000",
            "showEasing": "swing",
            "hideEasing": "linear",
            "showMethod": "fadeIn",
            "hideMethod": "fadeOut"
        };

        toastr.success(text);
    };

    renderButtons = () => {

        const enableDel = this.props.claimKey["EnableDel"] ?? 1;
        const enableSend = this.props.claimKey["EnableSend"] ?? 1;
        const enableWrite = this.props.claimKey["EnableWrite"] ?? 1;

        return (
            <div className="modal-footer text-right">
                {enableSend === 1 &&
                    <button type="button" className="btn btn-regular -goahead ml1ex" style={{"float": "left"}}
                            onClick={this.pass}>
                        {this.state.buttonTextSign || i18next.t("Sign_Send_Request_To_HR")}
                    </button>}
                {enableWrite === 1 && <button type="button" className="btn btn-regular -goahead ml1ex" onClick={this.save}>
                    {this.state.buttonTextSave || i18next.t("Save_Request")}
                </button>}
                {enableDel === 1 && <button type="button" className="btn btn-regular -goahead ml1ex" onClick={(e) => this.delete(e)}>
                    {this.state.buttonTextDel || i18next.t("RemoveStatement")}
                </button>}
                <button type="button" className="btn btn-regular -godefault ml1ex" data-dismiss="modal"
                        onClick={() => this.props.onClose(false)}>{this.state.buttonTextCancel || i18next.t("Cancel_Noun")}</button>
            </div>
        );
    };

    render() {

        const enableWrite = this.props.claimKey["EnableWrite"] ?? 1;

        return (
            <>
                <PopupWrapper popupVisible={true} title={i18next.t("Edit_Request")}
                              onClose={this.props.onClose} renderButtons={this.renderButtons} instructionId="11">
                    <ComplexParam dataItem={this.props.ClaimPersGetClaimData} dispatch={this.props.dispatch}
                                  renderParams={this.renderForm}
                                  autoApplyParams={false}
                                  rootPath="/"
                                  customFieldExMap={createTaskCustomFieldExMap}
                                  readOnly={!enableWrite}
                    />

                </PopupWrapper>
            </>
        );
    }

    renderForm = (h) => {

        if (!this.state.templateText)
            return <>{i18next.t("NoData")}</>;

        return <>
            {
                parse(this.state.templateText, {
                    replace: domNode => {
                        if (domNode.name === "label" && domNode.attribs && domNode.attribs.name) {
                            return this.renderLabel(h, domNode.attribs.name);
                        } else if (domNode.name === "editor" && domNode.attribs && domNode.attribs.name) {
                            return <>{h.ed(domNode.attribs.name)}</>
                        }

                        return domNode;
                    }
                })}
        </>;
    }

    renderLabel = (h, fieldName) => {

        if (fieldName == null || fieldName === "")
            return null;

        const {row, rowIndex, fi} = h;
        const fieldInfo = fi(fieldName);
        if (!fieldInfo)
            return null;

        const dataItem = this.props.ClaimPersGetClaimData;

        let underlyingFi = fieldInfo;

        if (fieldInfo.Action.VirtCol) {
            const row = dataItem.getRow(rowIndex);
            underlyingFi = dataItem.getFieldInfo(row[fieldInfo.Name]);
            if (!underlyingFi) {
                underlyingFi = fieldInfo;
            }
        }

        let labelText = dataItem.getTitle(fieldInfo, rowIndex)

        if (GlobalDebugMode) {
            labelText = labelText + " [" + fieldInfo.Name + "] RO: " + JSON.stringify(dataItem.getFieldIsReadOnly(fieldInfo, rowIndex));
        }

        if (!dataItem.getFieldIsReadOnly(fieldInfo, rowIndex) && dataItem.getFieldIsRequired(fieldInfo, rowIndex)) {

            const val = !!row ? row[underlyingFi.Name] : dataItem.getField(rowIndex, underlyingFi.Name);

            if (val == null || val === "") {
                return (<>{labelText}&nbsp;<span style={{color: "red"}}>*</span>{val}</>);
            }
        }

        return <>{labelText}</>
    }
}

EditClaim.propTypes = {
    dispatch: PropTypes.func.isRequired,
    ClaimPersGetClaimData: PropTypes.object,
    onClose: PropTypes.func,
    claimKey: PropTypes.object
};

EditClaim.defaultProps = {
    onClose: () => {
    },
    claimKey: {}
};

function mapStateToProps(state, ownProps) {
    return {
        ClaimPersGetClaimData: state.claimState.ClaimPersGetClaimData,
        ClaimPersSendClaimForPO: state.claimState.ClaimPersSendClaimForPO,
        ClaimPersListForPO_Del: state.claimState.ClaimPersListForPO_Del,
        ClaimPersGetClaimTempl: state.claimState.ClaimPersGetClaimTempl,
    }
}

export default connect(mapStateToProps)(EditClaim);